// -----------------------------------------------------------------------------
//
// This file is the copyrighted property of Tableau Software and is protected
// by registered patents and other applicable U.S. and international laws and
// regulations.
//
// Unlicensed use of the contents of this file is prohibited. Please refer to
// the NOTICES.txt file for further details.
//
// -----------------------------------------------------------------------------
import * as _ from 'underscore';
import { reloadSpace } from '../../app/sagas/spaces/content/RefreshContentSagas';
import { ExtractEncryptionState, IDataSourceInfo } from '../models/IDataSourceInfo';
import { IWorkbookInfo } from '../models/IWorkbookInfo';
import { IExtractItemInfo } from '../models/resourceInfoParts';
import { Module } from '../Module';
import { IPollExtractActionStatusResult, PollExtractActionStatusRequest } from '../ServerApi/requests/PollExtractActionStatusRequest';
import { CreateExtractTasksAction, ExctractActionType } from './CreateExtractTasksAction';
import { IPoller, PollService } from './PollService';

export class ExtractActionStatusService {

  private extractActionStatusInterval = 10000; // Polling interval of 10 secs
  private statusPoller: IPoller<IPollExtractActionStatusResult>;

  public static $inject = [
    'PollService',
    'CreateExtractTasksAction'
  ];

  constructor(
    private pollService: PollService,
    private createExtractTasksAction: CreateExtractTasksAction
  ) {}

  public pollAndUpdateExtractActionStatus(contentItem: IWorkbookInfo | IDataSourceInfo) {

    if (!(contentItem as IExtractItemInfo).extractCreationPending &&
      (contentItem as IExtractItemInfo).extractEncryptionState !== ExtractEncryptionState.pendingDecryption &&
      (contentItem as IExtractItemInfo).extractEncryptionState !== ExtractEncryptionState.pendingEncryption) {
        // no pending status, do nothing
        return;
    }
    const actionType: string = contentItem.extractCreationPending ? ExctractActionType.createExtracts:
      (contentItem.extractEncryptionState === ExtractEncryptionState.pendingEncryption ? ExctractActionType.encryptExtract: ExctractActionType.decryptExtract);
    this.pollExtractActionStatus(contentItem.id, contentItem.contentType, actionType).then(
      (result: IPollExtractActionStatusResult) => {
        //completed
        if(this.isExtractActionStatusValid(result)) {
          this.createExtractTasksAction.pollExtractActionStatus(contentItem, actionType, result);
          if (!_.isUndefined(result.pending) && !result.pending) {
            reloadSpace();
          }
        }
      },
      () => {
        // error, if error happened, stop to poll the pending status, 
        this.cancelExtractActionStatusPolling();
      }
    );
  }

  private isExtractActionStatusValid(data: IPollExtractActionStatusResult): boolean {
    if(data && data.pending) {
      return false;
    }
    // This failed due to invalid data we want to cancel the polling
    this.cancelExtractActionStatusPolling();
    return true;
  }

  private pollExtractActionStatus(contentId: string, contentType: string, actionType: string): ng.IPromise<any> {
    const isComplete = (result: IPollExtractActionStatusResult): boolean => {
      return result && !result.pending;
    };

    this.statusPoller = this.pollService.poll(new PollExtractActionStatusRequest({id: contentId, contentType: contentType, actionType: actionType}), isComplete, this.extractActionStatusInterval);
    return this.statusPoller.promise;
  }

  public cancelExtractActionStatusPolling() {
    if(!_.isUndefined(this.statusPoller)) {
      this.statusPoller.cancel();
    }
  }
}

Module.instance().service('ExtractActionStatusService', ExtractActionStatusService);
